import { render, staticRenderFns } from "./TermsPopup.vue?vue&type=template&id=6fac67f0&scoped=true"
import script from "./TermsPopup.vue?vue&type=script&lang=js"
export * from "./TermsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac67f0",
  null
  
)

export default component.exports